import React, { useEffect, useRef, useState } from 'react';
import { FaFilter, FaEdit } from "react-icons/fa";
import { AiFillDelete } from "react-icons/ai";
import { Link, useNavigate } from 'react-router-dom';
import Modal from '../../../CommonComponents/Popup';
import { FaCheckCircle } from "react-icons/fa";
import { CgUnavailable } from "react-icons/cg";
import { FaRedo } from "react-icons/fa";
// import { useDispatch } from 'react-redux';
// import { pro } from '../../../../../Store/ItemSlice';
import PaginationComponent from '../../pagination';
import { useRole } from '../../../../../Routing/Routing';
import { FaBoxOpen } from "react-icons/fa";
import { FaBox } from "react-icons/fa";
import Select from "react-select";
import { MagnifyImage } from '../../../CommonComponents/MagnifyImage';
import { LoadingWait } from '../../../CommonComponents/LoadingWait';
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

function Items() {

    const BASE_URL = process.env.REACT_APP_PP_URL;
    const { userPermissions } = useRole();
    const permission = (url) => userPermissions.includes(url);

    const listRef = useRef(null);
    const token = sessionStorage.getItem('tokenKey');
    const [action, setAction] = useState();
    const [popup, setPopup] = useState(false);

    // ITME LIST
    // const [list, setList] = useState([]);
    const [filterList, setFilterList] = useState({});
    const [getID, setGetId] = useState();

    // ALL ITEMS LISTS
    const [type, setType] = useState('');
    useEffect(() => {
        if (filters.active !== null) {
            if (filters.active === true) {
                setType("ACTIVE");
            } else if (filters.active === false) {
                setType("INACTIVE");
            }
        } else if (filters.deleted) {
            setType("DELETED");
        } else if (filters.stockOut) {
            setType("STOCKOUT");
        } else {
            setType("ALL");
        }
    }, []);

    const [isLoading, setIsLoading] = useState(false);
    const itemPerPage = JSON.parse(sessionStorage.getItem("itemPerPage"));
    const getPage = sessionStorage.getItem("currentPage") || 1;

    const [filters, setFilters] = useState(() => {
        const savedFilters = sessionStorage.getItem("itemFilters");
        return savedFilters
            ? JSON.parse(savedFilters)
            : {
                search: null,
                active: true,
                deleted: null,
                stockOut: null,
                keyword: null,
                publisherId: null,
                categoryId: null,
                subCategoryId: null,
                sortBy: null,
                pageNumber: Number(getPage) - 1 || 0,
                pageSize: itemPerPage?.value ? Number(itemPerPage.value) : 50,
            };
    });

    const masterApi = async (appliedFilters = filters) => {
        setIsLoading(true);
        setFilters(appliedFilters);
        // console.log(appliedFilters, "applied filter");
        sessionStorage.setItem("itemFilters", JSON.stringify(appliedFilters));

        // const itemPerPage = JSON.parse(sessionStorage.getItem("itemPerPage"));
        // const getPage = sessionStorage.getItem("currentPage") || 1;
        // const pageSize = itemPerPage.value || 50;

        // const payload = {
        //     pageNumber: Number(getPage) - 1,
        //     pageSize: Number(pageSize),
        //     ...appliedFilters
        // };

        try {
            const res = await fetch(`${BASE_URL}/admin/v1/item/list`, {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(appliedFilters)
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                // setList(getRes.responsePacket.content);
                setFilterList(getRes.responsePacket);
                setSelectedItems([]);
                setIsSelectAll(false);
                const savedScrollPosition = sessionStorage.getItem("scrollPosition");
                if (savedScrollPosition && listRef.current) {
                    listRef.current.scrollTo(0, parseInt(savedScrollPosition, 10))
                };
                // setSortBy();
            }
        } catch (e) {
            console.log(e, "error in master api");
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        // sessionStorage.setItem("itemFilters", JSON.stringify(filters));
        masterApi(filters);
    }, []);

    // const items = async (data) => {
    //     setIsLoading(true);

    //     try {
    //         const res = await fetch(`${BASE_URL}/admin/v1/item/list-data/${data}`, {
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'Authorization': `Bearer ${token}`
    //             }
    //         });
    //         const getRes = await res.json();
    //         if (getRes.errorCode === 0) {
    //             setList(getRes.responsePacket);
    //             setFilterList(getRes.responsePacket);
    //             setSelectedItems([]);
    //             setIsSelectAll(false);
    //             const savedScrollPosition = sessionStorage.getItem("scrollPosition");
    //             if (savedScrollPosition && listRef.current) {
    //                 listRef.current.scrollTo(0, parseInt(savedScrollPosition, 10))
    //             };
    //             setSortBy();
    //             setIsLoading(false);
    //         }
    //         setInputSearch("");
    //         setCategoryValue(null);
    //         setPublisherValue(null);
    //     } catch (e) {
    //         console.log(e, 'error in itme list');
    //     }
    // };

    // useEffect(() => {
    //     // items('Active');
    // }, []);

    // ACIVE API AND INACTIVE API

    const activeItem = async (uuid) => {
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/item/activate/${uuid}`, {
                method: "PUT",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            })
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                // Assuming listType is a variable that determines which data list to set
                // switch (type) {
                //     case "ALL":
                //         await items("ALL");
                //         break;
                //     case "ACTIVE":
                //         await items("Active");
                //         break;
                //     case "INACTIVE":
                //         await items("Inactive");
                //         break;
                //     case "DELETED":
                //         await items('Deleted');
                //         break;
                //     default:
                //         console.log("Unknown list type");
                // }
                masterApi(filters);
            } else {
                console.log('Error in response');
            }
            // setInputSearch("");
        } catch (e) {
            console.log(e, 'error in active itme api')
        }
    };

    // INACTIVE ITEMS
    const inactiveItem = async (uuid) => {
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/item/inactivate/${uuid}`, {
                method: "PUT",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                // Assuming listType is a variable that determines which data list to set
                // switch (type) {
                //     case "ALL":
                //         await items("ALL");
                //         break;
                //     case "ACTIVE":
                //         await items("Active");
                //         break;
                //     case "INACTIVE":
                //         await items("Inactive");
                //         break;
                //     case "DELETED":
                //         await items('Deleted');
                //         break;
                //     default:
                //         console.log("Unknown list type");
                // }
                masterApi(filters);
            } else {
                console.log('Error in response');
            }
            setInputSearch("");
        } catch (e) {
            console.log(e, 'error in inactive api of itme')
        }
    };

    // DELTED ITEMS FROM ITEMS
    const removeItems = async (uuid) => {
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/item/delete/${uuid}`, {
                method: "DELETE",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                // Assuming listType is a variable that determines which data list to set
                // switch (type) {
                //     case "ALL":
                //         await items("ALL");
                //         break;
                //     case "ACTIVE":
                //         await items("Active");
                //         break;
                //     case "INACTIVE":
                //         await items("Inactive");
                //         break;
                //     case "DELETED":
                //         await items('Deleted');
                //         break;
                //     default:
                //         console.log("Unknown list type");
                //         break;
                // }
                masterApi(filters);
            } else {
                console.log('Error in response');
            }
            setInputSearch("");
        } catch (e) {
            console.log(e, 'error in delted itms api')
        }
    };

    // REVIVE ITEMS
    const revive = async (uuid) => {
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/item/revive/${uuid}`, {
                method: "PUT",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                // Assuming listType is a variable that determines which data list to set
                // switch (type) {
                //     case "ALL":
                //         await items("ALL");
                //         break;
                //     case "ACTIVE":
                //         await items("Active");
                //         break;
                //     case "INACTIVE":
                //         await items("Inactive");
                //         break;
                //     case "DELETED":
                //         await items('Deleted');
                //         break;
                //     default:
                //         console.log("Unknown list type");
                //         break;
                // }
                masterApi(filters);
            } else {
                console.log('Error in response');
            }
            setInputSearch("");
        } catch (e) {
            console.log(e, 'error in revive api')
        }
    };

    // HANDEL REVIVE API
    const handelRevive = (uuid) => {
        setAction('RESTORE');
        setPopup(true);
        setGetId(uuid);
    };

    // HANDEL DELTED
    const handelDeleted = (uuid) => {
        setAction('DELETED');
        setGetId(uuid);
        setPopup(true);
    };

    // HANDEL ACTIVE AND INACTIVE SECTIONS
    const handelActive = (uuid) => {
        setAction('ACTIVE');
        setGetId(uuid);
        setPopup(true);
    };

    const handelInactive = (uuid) => {
        setAction('INACTIVE');
        setGetId(uuid);
        setPopup(true);
    };

    // CONFIRM POP UP
    const confirmPop = async () => {
        if (popup) {
            switch (action) {
                case 'ACTIVE': await activeItem(getID);
                    break;
                case 'INACTIVE':
                    await inactiveItem(getID);
                    break;
                case "DELETED":
                    await removeItems(getID);
                    break;
                case 'RESTORE':
                    await revive(getID);
                    await activeItem(getID)
                    break;
                case 'Out Of Stoke':
                    await stoke(getID);
                    break;
                case "Stock-in":
                    await stoke(getID);
                    break;
                case "Inactive the selected":
                    await multipleInactive();
                    setPopup(false);
                    break;
                case "Active the selected":
                    await multipleActive();
                    setPopup(false);
                    break;
                default:
                    console.log('no such action available');
                    break;
            }
        };
        setAction('');
        setPopup(false);
    };

    // CANCEL THE POPUP
    const closePop = () => {
        setPopup(false);
        setAction('');
    };

    // UPDATE ITEMS
    // const dispatch = useDispatch();
    const navigate = useNavigate();
    const updateItem = async (recordId) => {
        if (listRef.current) {
            sessionStorage.setItem("scrollPosition", listRef.current.scrollTop);
            // console.log("run run run run run");
        }
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/item/get/${recordId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                // dispatch(pro(getRes?.responsePacket));
                navigate(`/admin/UpdateItem/${getRes?.responsePacket.uuid}`, { state: getRes?.responsePacket });
            };
        } catch (e) {
            console.log(e, 'error in update api');
        };
        // window.open(recordId,"_blank",'noopener,noreferrer');
    };

    // HANDLE STOKE AND OUTOFSTOKE
    const stoke = async (uuid) => {
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/item/update-stock-out/${uuid}`, {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                // Assuming listType is a variable that determines which data list to set
                // switch (type) {
                //     case "ALL":
                //         await items("ALL");
                //         break;
                //     case "ACTIVE":
                //         await items("Active");
                //         break;
                //     case "INACTIVE":
                //         await items("Inactive");
                //         break;
                //     case "DELETED":
                //         await items('Deleted');
                //         break;
                //     default:
                //         console.log("Unknown list type");
                // }
                masterApi(filters);
            } else {
                console.log('Error in response');
            }
            // setInputSearch("");
        } catch (e) {
            console.log(e, 'error in stoke api')
        }
    };

    const handleStoke = (uuid) => {
        setAction('Out Of Stoke');
        setGetId(uuid);
        setPopup(true);
    };
    //  Stock-in
    const handleStokeIn = (uuid) => {
        setAction('Stock-in');
        setGetId(uuid);
        setPopup(true);
    };

    const getCurrentPage = sessionStorage.getItem("currentPage");
    const [currentPage, setCurrentPage] = useState(getCurrentPage ? getCurrentPage : 1);
    const [hasInteracted, setHasInteracted] = useState(false);

    useEffect(() => {
        if (!hasInteracted) return; // ✅ skip initial mount
        if (currentPage) {
            masterApi({ ...filters, pageNumber: currentPage - 1 });
            setHasInteracted(false);
        }
    }, [currentPage, hasInteracted]);

    const scrollToTopOnPageChange = () => {
        listRef.current.scrollTo(0, 0);
    };

    const [inputSearch, setInputSearch] = useState(() => filters.keyword ? sessionStorage.getItem("itemSearch") : '');
    const [hasTyped, setHasTyped] = useState(false);

    useEffect(() => {
        if (!hasTyped) return;
        const timer = setTimeout(() => {
            if (inputSearch?.length > 2) {
                sessionStorage.setItem("itemSearch", inputSearch);
                sessionStorage.setItem("currentPage", 1);
                setCurrentPage(1);
                masterApi({ ...filters, keyword: inputSearch, pageNumber: 0, sortBy: null, });
                setHasTyped(false);
            } else if (inputSearch?.length === 0) {
                // setFilterList(list);
                // sessionStorage.setItem("itemSearch", inputSearch);
                sessionStorage.setItem("currentPage", 1);
                masterApi({ ...filters, keyword: null, pageNumber: 0, sortBy: null, })
                setCurrentPage(1);
                sessionStorage.removeItem("itemSearch");
                setHasTyped(false);
            }
        }, 500);
        return () => clearTimeout(timer);

    }, [inputSearch, hasTyped]);

    // const handleSearch = (e, isSearch) => {
    //     const get = e;
    //     if (!isSearch) {
    //         // handleSort("Remove Filter");
    //         // sessionStorage.setItem("itemSearch,", get);
    //         setCurrentPage(1);
    //         sessionStorage.setItem("currentPage", 1);
    //         sessionStorage.removeItem("scrollPosition");
    //         // sessionStorage.removeItem("filterByCategory");
    //         // sessionStorage.removeItem("filterByPublisher");
    //         // setCategoryValue(null);
    //         // setPublisherValue(null);
    //     }
    //     setInputSearch(get);

    //     if (get && get?.length > 2) {
    //         // sessionStorage.setItem("itemSearch", e);
    //         // const search = list.filter((itm) =>
    //         //     itm.title?.toLowerCase()?.includes(get.toLowerCase()) ||
    //         //     itm.description?.toLowerCase()?.includes(get.toLowerCase()) ||
    //         //     itm.itemCode?.toLowerCase()?.includes(get.toLowerCase()) ||
    //         //     itm.parentCategoryDetails.some(cate => cate.parentTitle.toLowerCase().includes(get.toLowerCase())) ||
    //         //     itm.subCategoryDetails.some(cate => cate.parentTitle.toLowerCase().includes(get.toLowerCase())) ||
    //         //     JSON.parse(itm.otherDataJson || "{}").author?.toLowerCase()?.includes(get.toLowerCase())
    //         // ).sort((a, b) => a.title.localeCompare(b.title));
    //         // setFilterList(search);
    //         masterApi({ ...filters, keyword: get })

    //     } else {
    //         // setFilterList(list);
    //         masterApi({ ...filters, keyword: null })
    //         sessionStorage.removeItem("itemSearch");
    //     }
    // };

    // useEffect(() => {
    //     const itemSearch = sessionStorage.getItem("itemSearch");
    //     if (itemSearch) {
    //         setTimeout(() => {
    //             handleSearch(itemSearch, true);
    //         }, 500);
    //     }
    // }, [list]);

    // FILTER LIST

    const [sortShow, setSortShow] = useState(false);

    // HANDLE OUTSIDE CLICK
    const ref = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!ref?.current?.contains(event.target)) {
                setSortShow(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
    }, [ref]);

    // SORT METHOD
    const sortFilter = sessionStorage.getItem("sortFilterOFItem");
    const sort = [
        { id: 1, title: "A-Z" },
        { id: 2, title: "Z-A" },
        { id: 4, title: "Latest Added" },
        { id: 5, title: "Oldest Added" },
        { id: 6, title: "High to Low price" },
        { id: 7, title: "Low to High price" },
        // { id: 8, title: "Out of Stock" },
    ];

    const [sortBy, setSortBy] = useState(() => filters.sortBy ? sortFilter : "");

    const handleSort = async (by, isScroll) => {
        setSortBy(by);
        sessionStorage.setItem("sortFilterOFItem", by);
        if (isScroll) {
            const savedScrollPosition = sessionStorage.getItem("scrollPosition");
            listRef.current.scrollTo(0, parseInt(savedScrollPosition, 10))
        } else {
            sessionStorage.removeItem("scrollPosition");
            sessionStorage.removeItem("itemSearch");
            sessionStorage.setItem("currentPage", 1);
            setCurrentPage(1);
        }
        if (by === 'A-Z') {
            // const sortAz = [...list].sort((a, b) => a.title.toLowerCase().localeCompare(b.title.toLowerCase()));
            // setFilterList(sortAz);
            masterApi({ ...filters, keyword: null, sortBy: "A-Z" })
            setSortShow(false);
            // setInputSearch('');
        } else if (by === "Z-A") {
            // const sortAz = [...list].sort((a, b) => b.title.toLowerCase().localeCompare(a.title.toLowerCase()));
            // setFilterList(sortAz);
            masterApi({ ...filters, keyword: null, sortBy: "Z-A" })
            // setInputSearch('');
            setSortShow(false);
        } else if (by === 'Latest Added') {
            // const sortAz = [...list].sort((a, b) => b.createdAtTimeStamp - a.createdAtTimeStamp);
            // setFilterList(sortAz);
            masterApi({ ...filters, keyword: null, sortBy: "LatestAdded" });
            // setInputSearch('');
            setSortShow(false);
        } else if (by === 'Oldest Added') {
            // const sortAz = [...list].sort((a, b) => a.createdAtTimeStamp - b.createdAtTimeStamp);
            // setFilterList(sortAz);
            masterApi({ ...filters, keyword: null, sortBy: "OldestAdded" });
            setInputSearch('');
            setSortShow(false);
        } else if (by === 'High to Low price') {
            // const sortAz = [...list].sort((a, b) => b.mrp - a.mrp);
            // setFilterList(sortAz);
            masterApi({ ...filters, keyword: null, sortBy: "PriceHighLow" });
            setInputSearch('');
            setSortShow(false);
        } else if (by === 'Low to High price') {
            // const sortAz = [...list].sort((a, b) => a.mrp - b.mrp);
            // setFilterList(sortAz);
            masterApi({ ...filters, keyword: null, sortBy: "PriceLowHigh" });
            // setInputSearch('');
            setSortShow(false);
        }
        //  else if (by === 'Out of Stock') {
        //     const sortAz = [...list].filter((itm) => itm.stockOut === true);
        //     setFilterList(sortAz);
        //     setInputSearch('');
        //     setSortShow(false);
        // } 
        else if (by === "Remove Filter") {
            masterApi({ ...filters, keyword: null, sortBy: null });
            // setFilterList(list);
            setSortBy('');
            // setInputSearch('');
            setSortShow(false);
        }
    };

    // useEffect(() => {
    //     const sortFilter = sessionStorage.getItem("sortFilterOFItem");
    //     if (sortFilter) {
    //         // handleSort(sortFilter, true);
    //         // listRef.current.scrollTo(0, parseInt(savedScrollPosition, 10))
    //     }
    // }, [list]);

    const resultPerPage = [
        { value: 10, label: "10 items per page" },
        { value: 20, label: "20 items per page" },
        { value: 50, label: "50 items per page" },
        { value: 100, label: "100 items per page" },
        { value: 200, label: "200 items per page" },
    ];

    const [lengthOfPage, setLengthOfPage] = useState(() => {
        return filters.pageSize ? { value: filters.pageSize, label: `${filters.pageSize} items per page` } : resultPerPage[2]
    });

    useEffect(() => {
        sessionStorage.setItem("itemPerPage", JSON.stringify(lengthOfPage));
    }, [lengthOfPage]);


    // Pagination logic
    const itemsPerPage = lengthOfPage?.value; // Show 10 items per page
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    const timeFormate = (time) => {
        const date = new Date(time);
        const options = {
            day: 'numeric',    // 5
            month: 'numeric',    // Dec
            year: 'numeric',   // 2024
            hour: '2-digit',   // 10
            minute: '2-digit',
            hour12: true
        };
        const formattedDate = new Intl.DateTimeFormat('en-GB', options).format(date);
        return formattedDate
    };

    // Filter By Publihser
    const [getPublisherList, setGetPublisherList] = useState([]);
    const [filterPublisherList, setFilterPublisherList] = useState([...getPublisherList]);

    const publisherList = async () => {
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/publisher/list-in-key-value`, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                setGetPublisherList(getRes.responsePacket.sort((a, b) => a.label.localeCompare(b.label)));
                setFilterPublisherList(getRes.responsePacket.sort((a, b) => a.label.localeCompare(b.label)));
            }
        } catch (e) {
            console.log(e, "error in publisher List api");
        }
    };
    useEffect(() => {
        publisherList();
        categoryList();
    }, []);

    // const [listLite, setListLite] = useState([...list]);

    const [publisherValue, setPublisherValue] = useState(() => {
        const stored = sessionStorage.getItem("filterByPublisher");
        return filters?.publisherId && stored ? JSON.parse(stored) : null;
    });

    useEffect(() => {
        const stored = sessionStorage.getItem("filterByPublisher");
        if (stored) {
            try {
                setPublisherValue(JSON.parse(stored));
            } catch (e) {
                console.error("Invalid JSON in sessionStorage:", e);
            }
        }
    }, []);

    const filterByPublisher = (e, isTrue) => {
        sessionStorage.setItem("filterByPublisher", JSON.stringify(e));
        sessionStorage.removeItem("itemSearch");
        setInputSearch("");
        setPublisherValue(e);
        if (!isTrue) {
            sessionStorage.setItem("currentPage", 1);
            sessionStorage.removeItem("scrollPosition");
            // handleSort("Remove Filter");
        };
        setCurrentPage(1);

        sessionStorage.setItem("currentPage", 1);
        if (e) {
            masterApi({ ...filters, publisherId: e.value, pageNumber: 0, sortBy: null, keyword: null });
            // if (categoryValue) {
            //     const res = listLite.filter((itm) => itm?.publisherDetails?.parentUuid === e?.value);
            //     setFilterList(res);
            //     // setCategoryValue(null)
            // } else if (!categoryValue) {
            //     const res = list.filter((itm) => itm?.publisherDetails?.parentUuid === e?.value);
            //     setFilterList(res);
            //     setListLite(res);

            // }
        } else if (!e) {
            // setFilterList(list);
            masterApi({ ...filters, publisherId: null, pageNumber: 0, sortBy: null, keyword: null });
        }
    };

    // useEffect(() => {
    //     const filterr = JSON.parse(sessionStorage.getItem("filterByPublisher"));
    //     if (filterr) {
    //         setTimeout(() => {
    //             filterByPublisher(filterr, true);
    //         }, 500);
    //     }
    // }, [list]);

    // Filter Category 
    const [getCategoryList, setGetCategoryList] = useState([]);
    const [categoryValue, setCategoryValue] = useState(() => filters?.categoryId ? JSON.parse(sessionStorage.getItem("filterByCategory")) : null);

    const categoryList = async () => {
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/category/parent-category-list-in-key-value`, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                setGetCategoryList(getRes.responsePacket.sort((a, b) => a.label.localeCompare(b.label)));
            }
        } catch (e) {
            console.log(e, "error in category list api")
        }
    };

    const filterByCategory = (e, isTrue) => {
        sessionStorage.setItem("filterByCategory", JSON.stringify(e));

        sessionStorage.removeItem("itemSearch");
        setInputSearch("");
        setCategoryValue(e);
        if (!isTrue) {
            setCurrentPage(1);
            sessionStorage.setItem("currentPage", 1);
            sessionStorage.removeItem("scrollPosition");
            // handleSort("Remove Filter");
        }
        if (e) {
            // if (publisherValue) {
            //     const res = listLite.filter((itm) => itm.parentCategoryDetails.some((itm) => itm.parentUuid === e.value) || itm.subCategoryDetails.some((itm) => itm.parentUuid === e.value));
            //     setFilterList(res);
            // } else if (!publisherValue) {
            //     const res = list.filter((itm) => itm.parentCategoryDetails.some((itm) => itm.parentUuid === e.value) || itm.subCategoryDetails.some((itm) => itm.parentUuid === e.value));
            //     setFilterList(res);
            //     setListLite(res);
            // }
            masterApi({ ...filters, categoryId: e.value, pageNumber: 0, sortBy: null, keyword: null });
            sessionStorage.setItem("currentPage", 1);
            // setPublisherValue(null);
        } else if (!e) {
            // setFilterList(list);
            masterApi({ ...filters, categoryId: null, subCategoryId: null, pageNumber: 0, sortBy: null, keyword: null });
        }
    };

    const [subCategoryList, setSubCategoryList] = useState([]);
    const [selectedSubCategory, setSelectedSubCategory] = useState(() => filters?.subCategoryId ? JSON.parse(sessionStorage.getItem("filterBySubCategory")) : null);

    const getSubCategoryList = async (parentCategoryUuid) => {
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/category/sub-category-list-in-key-value/${parentCategoryUuid}`, {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                setSubCategoryList(getRes.responsePacket);
            }
        } catch (e) {
            console.log(e, "error in sub Category");
        }
    };

    useEffect(() => {
        if (categoryValue) {
            getSubCategoryList(categoryValue.value);
        }
    }, [categoryValue]);

    useEffect(() => {
        if (!categoryValue) {
            setSelectedSubCategory(null)
        }
    }, [categoryValue])

    const filterBySubCategory = (e) => {
        sessionStorage.setItem("filterBySubCategory", JSON.stringify(e));

        sessionStorage.removeItem("itemSearch");
        setInputSearch("");
        setSelectedSubCategory(e);
        if (e) {
            masterApi({ ...filters, subCategoryId: e.value, pageNumber: 0, sortBy: null, keyword: null });
            sessionStorage.setItem("currentPage", 1);
        } else if (!e) {
            masterApi({ ...filters, subCategoryId: null, pageNumber: 0, sortBy: null, keyword: null });
            sessionStorage.setItem("currentPage", 1);
        }
    };
    // useEffect(() => {
    //     const filterr = JSON.parse(sessionStorage.getItem("filterByCategory"));
    //     if (filterr) {
    //         // console.log(filterr, "filterBy")
    //         setTimeout(() => {
    //             filterByCategory(filterr, true);
    //         }, 500);
    //     }
    // }, []);

    // Image Magifinify
    const [imgUrl, setImgUrl] = useState();
    const [showImg, setShowImg] = useState(false);
    const maginifyImage = (e) => {
        setShowImg(true);
        setImgUrl(e);
    };

    // Multiple active and inactive 
    const [selectedItems, setSelectedItems] = useState([]);
    const [isSelectAll, setIsSelectAll] = useState(false);

    const handleSelectAll = () => {
        if (isSelectAll) {
            setSelectedItems([]); // Deselect all items
        } else {
            setSelectedItems(filterList.content.map((itm) => itm)); // Select all items
        }
        setIsSelectAll(!isSelectAll);
    };

    const handleCheckboxChange = (itemId) => {
        setSelectedItems((prevSelected) =>
            prevSelected.includes(itemId)
                ? prevSelected.filter((id) => id !== itemId) // Uncheck if already selected
                : [...prevSelected, itemId] // Add to selected items
        );
    };

    const multipleActive = async () => {
        try {
            const data = selectedItems.filter((itm) => itm.active === false).map((itm) =>
                fetch(`${BASE_URL}/admin/v1/item/activate/${itm.uuid}`, {
                    method: "PUT",
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    }
                }).then(async (response) => {
                    return await response.json();
                })
            )
            const res = await Promise.all(data);
            const allSuccess = res.every((response) => response.errorCode === 0);
            if (allSuccess) {
                // switch (type) {
                //     case "ALL":
                //         await items("ALL");
                //         break;
                //     case "ACTIVE":
                //         await items("Active");
                //         break;
                //     case "INACTIVE":
                //         await items("Inactive");
                //         break;
                //     case "DELETED":
                //         await items('Deleted');
                //         break;
                //     default:
                //         console.log("Unknown list type");
                // }
                masterApi(filters);
                // setSelectedItems([]);
                // setCurrentPage(1);
                // sessionStorage.setItem("currentPage", 1);
                // sessionStorage.removeItem("scrollPosition");
            }

        } catch (e) {
            console.log(e, "error in multiple")
        }
    };

    const handleMultiActive = () => {
        setPopup(true);
        setAction("Active the selected")
    };

    const multipleInactive = async () => {
        try {
            const data = selectedItems.filter((itm) => itm.active === true).map((itm) =>
                fetch(`${BASE_URL}/admin/v1/item/inactivate/${itm.uuid}`, {
                    method: "PUT",
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    }
                }).then(async (response) => {
                    return await response.json();
                })
            )
            const res = await Promise.all(data);
            const allSuccess = res.every((response) => response.errorCode === 0)
            if (allSuccess) {
                // setSelectedItems([]);
                // setCurrentPage(1);
                // sessionStorage.setItem("currentPage", 1);
                // sessionStorage.removeItem("scrollPosition");
                // switch (type) {
                //     case "ALL":
                //         await items("ALL");
                //         break;
                //     case "ACTIVE":
                //         await items("Active");
                //         break;
                //     case "INACTIVE":
                //         await items("Inactive");
                //         break;
                //     case "DELETED":
                //         await items('Deleted');
                //         break;
                //     default:
                //         console.log("Unknown list type");
                //         break;
                // }
                masterApi(filters);
            };
        } catch (e) {
            console.log(e, "error in multiple")
        }
    };

    const handleMultiInactive = () => {
        setPopup(true);
        setAction("Inactive the selected")
    };

    // useEffect(() => {
    //     if (categoryValue === null) {
    //         // setPublisherValue(null); 
    //         // sessionStorage.removeItem("filterByPublisher");
    //     }
    // }, [categoryValue]);

    // useEffect(() => {
    //     if (publisherValue === null) {
    //         // setCategoryValue(null);
    //         // sessionStorage.removeItem("filterByCategory");/\
    //     }
    // }, [publisherValue]);

    const [downloadType, setDownloadType] = useState("pdf");
    const [downloadLoading, setDownloadLoading] = useState(false);

    const downloadPDF = async () => {
        setDownloadLoading(true);

        try {
            await new Promise(resolve => setTimeout(resolve, 100));
            const doc = new jsPDF();

            const rows = filterList?.content?.map((item, index) => [
                index + 1,
                item.title,
                timeFormate(item.createdAtTimeStamp),
                item.parentCategoryDetails?.map(cat => cat.parentTitle).join(", "),
                item.subCategoryDetails?.map(cat => cat.parentTitle).join(", "),
                item.itemCode,
                item.mrp,
                item.sellingPrice,
                item.active ? "Active" : "Inactive"
            ]) || [];

            autoTable(doc, {
                head: [[
                    "Sr No",
                    "Title",
                    "Created At",
                    "Parent Category",
                    "Sub Category",
                    "Item Code",
                    "MRP",
                    "Selling Price",
                    "Status"
                ]],
                body: rows,
            });

            doc.save("Items_List.pdf");
        } catch (error) {
            console.log(error);
        } finally {
            setDownloadLoading(false);
        }
    };

    const downloadExcel = async () => {
        setDownloadLoading(true);
        try {
            await new Promise(resolve => setTimeout(resolve, 100));
            const worksheet = XLSX.utils.json_to_sheet(
                filterList?.content?.map((item, index) => ({
                    "Sr No": index + 1,
                    "Title": item.title,
                    "Created At": timeFormate(item.createdAtTimeStamp),
                    "Parent Category": item.parentCategoryDetails?.map(cat => cat.parentTitle).join(", "),
                    "Sub Category": item.subCategoryDetails?.map(cat => cat.parentTitle).join(", "),
                    "Item Code": item.itemCode,
                    "MRP": item.mrp,
                    "Selling Price": item.sellingPrice,
                    "Status": item.active ? "Active" : "Inactive",
                })) || []
            );

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Items");

            XLSX.writeFile(workbook, "Items_List.xlsx");
        } catch (error) {
            console.log(error);
        } finally {
            setDownloadLoading(false);
        }
    };

    const downloadCSV = async () => {
        setDownloadLoading(true);
        try {
            await new Promise(resolve => setTimeout(resolve, 100));
            const worksheet = XLSX.utils.json_to_sheet(
                filterList?.content?.map((item, index) => ({
                    "Sr No": index + 1,
                    "Title": item.title,
                    "Created At": timeFormate(item.createdAtTimeStamp),
                    "Parent Category": item.parentCategoryDetails?.map(cat => cat.parentTitle).join(", "),
                    "Sub Category": item.subCategoryDetails?.map(cat => cat.parentTitle).join(", "),
                    "Item Code": item.itemCode,
                    "MRP": item.mrp,
                    "Selling Price": item.sellingPrice,
                    "Status": item.active ? "Active" : "Inactive",
                })) || []
            );

            const csv = XLSX.utils.sheet_to_csv(worksheet);

            const blob = new Blob([csv], {
                type: "text/csv;charset=utf-8;",
            });

            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = "Items_List.csv";
            link.click();
        } catch (error) {
            console.log(error);
        } finally {
            setDownloadLoading(false);
        }
    };
    const handleDownload = () => {
        switch (downloadType) {
            case "pdf":
                downloadPDF();
                break;

            case "excel":
                downloadExcel();
                break;

            case "csv":
                downloadCSV();
                break;

            default:
                break;
        }
    };

    return (
        <>
            <div className="category" style={{ display: "flex", justifyContent: "center" }}>
                <div className="row">
                    <div className="category-nav" >
                        <div className="category-text">
                            <h4>Items</h4>
                        </div>

                        <div className="category-btn" style={{ width: "80%" }}>

                            <Select
                                closeMenuOnSelect={true}
                                isClearable={true}
                                name="colors"
                                options={filterPublisherList}
                                value={publisherValue}
                                onChange={(e) => { filterByPublisher(e) }}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                placeholder="Filter by Publisher"
                            />

                            <Select
                                closeMenuOnSelect={true}
                                isClearable={true}
                                name="colors"
                                options={getCategoryList}
                                value={categoryValue}
                                onChange={(e) => { filterByCategory(e) }}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                placeholder="Filter by Category"
                            />

                            <Select
                                closeMenuOnSelect={true}
                                isClearable={true}
                                name="colors"
                                options={subCategoryList}
                                value={selectedSubCategory}
                                onChange={(e) => { filterBySubCategory(e) }}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                placeholder="Filter by sub Category"
                                isDisabled={!categoryValue}
                            />

                            <Select
                                defaultValue={resultPerPage[2]}
                                closeMenuOnSelect={true}
                                name="colors"
                                options={resultPerPage}
                                value={lengthOfPage}
                                onChange={(e) => { setLengthOfPage(e); setCurrentPage(1); sessionStorage.setItem("currentPage", 1); sessionStorage.removeItem("scrollPosition"); masterApi({ ...filters, pageSize: e.value }) }}
                                className="basic-multi-select"
                                classNamePrefix="select"
                            />

                            {
                                permission('admin/v1/item/save') && <Link to="/admin/additemparent" onClick={() => sessionStorage.removeItem("scrollPosition")}>
                                    <button style={{ fontWeight: "600" }}>Add Item</button>
                                </Link>
                            }
                        </div>
                    </div>
                    <hr />
                    <div className="category-filter">
                        <div className="filterr">
                            {
                                selectedItems.length > 0 ?
                                    <>
                                        <div className="btn-1">
                                            {(type === "INACTIVE" || type === "ALL") && <button style={{ backgroundColor: "#d4edda", color: "#155724", borderColor: "", border: "none" }} onClick={() => handleMultiActive()}>Active Items</button>}
                                        </div>
                                        <div className="btn-1">
                                            {(type === "ACTIVE" || type === "ALL") && <button style={{ backgroundColor: "#f8d7da", color: "#ff0019", borderColor: "", border: "none" }} onClick={() => handleMultiInactive()}>Inactive Items</button>}
                                        </div>
                                    </> :
                                    <>
                                        <div className="btn-1">
                                            <button style={{ backgroundColor: type === 'ALL' ? 'white' : 'black', color: type === 'ALL' ? 'black' : 'white' }} onClick={() => {
                                                masterApi({
                                                    search: null,
                                                    active: null,
                                                    deleted: null,
                                                    stockOut: null,
                                                    keyword: null,
                                                    publisherId: null,
                                                    categoryId: null,
                                                    subCategoryId: null,
                                                    sortBy: null,
                                                    pageNumber: Number(getPage) - 1 || 0,
                                                    pageSize: itemPerPage?.value ? Number(itemPerPage.value) : 50,

                                                }); setType('ALL'); setCurrentPage(1); sessionStorage.setItem("currentPage", 1); sessionStorage.removeItem("scrollPosition")
                                            }} >All</button>
                                        </div>
                                        <div className="btn-1">
                                            <button style={{ backgroundColor: type === 'ACTIVE' ? 'white' : 'black', color: type === 'ACTIVE' ? 'black' : 'white' }} onClick={() => {
                                                masterApi({ ...filters, active: true, deleted: null, stockOut: null }); setType('ACTIVE'); setCurrentPage(1); sessionStorage.setItem("currentPage", 1); sessionStorage.removeItem("scrollPosition")
                                            }}>Active</button>
                                        </div>
                                        <div className="btn-1">
                                            <button style={{ backgroundColor: type === 'INACTIVE' ? 'white' : 'black', color: type === 'INACTIVE' ? 'black' : 'white' }} onClick={() => { masterApi({ ...filters, active: false, deleted: null, stockOut: null }); setType('INACTIVE'); setCurrentPage(1); sessionStorage.setItem("currentPage", 1); sessionStorage.removeItem("scrollPosition") }}>Inactive</button>
                                        </div>
                                        <div className="btn-1">
                                            <button style={{ backgroundColor: type === 'STOCKOUT' ? 'white' : 'black', color: type === 'STOCKOUT' ? 'black' : 'white' }} onClick={() => { masterApi({ ...filters, active: null, deleted: null, stockOut: true }); setType('STOCKOUT'); setCurrentPage(1); sessionStorage.setItem("currentPage", 1); sessionStorage.removeItem("scrollPosition") }}>Stock Out</button>
                                        </div>
                                        <div className="btn-1">
                                            <button style={{ backgroundColor: type === 'DELETED' ? 'white' : 'black', color: type === 'DELETED' ? 'black' : 'white' }} onClick={() => { masterApi({ ...filters, active: null, deleted: true, stockOut: null }); setType('DELETED'); setCurrentPage(1); sessionStorage.setItem("currentPage", 1); sessionStorage.removeItem("scrollPosition") }}><AiFillDelete /></button>
                                        </div>
                                        <div className="btn-1">
                                            <button onClick={() => setSortShow(!sortShow)} style={{ backgroundColor: sortBy ? 'white' : 'black', color: sortBy ? 'black' : 'white' }}><FaFilter /></button>
                                            {
                                                sortShow && <div className="sort-list" ref={ref}>
                                                    {
                                                        sort.map((item) => {
                                                            return (
                                                                <>
                                                                    <div className="list-item" id="sort" onClick={() => handleSort(item.title, true)}>
                                                                        <div className="outer-c" >
                                                                            <div className="inner-c" style={{ backgroundColor: sortBy === item.title ? "black" : "" }}></div>
                                                                        </div>
                                                                        <label for={item.id}>{item.title}</label>
                                                                    </div>
                                                                </>
                                                            )
                                                        })
                                                    }
                                                    <div className="list-item" id="sort" onClick={() => handleSort("Remove Filter", true)}>
                                                        <label for="filter">Remove Filter</label>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </>
                            }

                            <div className="download-btn" style={{ display: "flex", alignItems: "center" }}>
                                <select
                                    value={downloadType}
                                    onChange={(e) => setDownloadType(e.target.value)}
                                    style={{
                                        height: "40px",
                                        marginRight: "10px",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px",
                                        padding: "0 10px",
                                        paddingBottom: "0px"
                                    }}
                                >
                                    <option value="pdf">PDF</option>
                                    <option value="excel">Excel</option>
                                    <option value="csv">CSV</option>
                                </select>

                                <div style={{ position: "relative", display: "inline-block" }}>
                                    <button className="download-btn"
                                        onClick={handleDownload}
                                        disabled={downloadLoading}
                                        style={{
                                            height: "42px",
                                            padding: "0 15px",
                                            backgroundColor: "black",
                                            color: "#fff",
                                            border: "none",
                                            borderRadius: "8px",
                                            marginTop: "-13px",
                                            cursor: downloadLoading ? "not-allowed" : "pointer",
                                            transition: "0.3s ease",
                                            filter: downloadLoading ? "blur(1.5px)" : "none",
                                            opacity: downloadLoading ? 0.7 : 1,
                                            pointerEvents: downloadLoading ? "none" : "auto",
                                            fontWeight: "600",
                                            cursor: "pointer",
                                            transition: "0.3s ease"
                                        }}
                                    >
                                        Download
                                    </button>
                                    {downloadLoading && (
                                        <div style={{
                                            position: "absolute",
                                            inset: 0,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            borderRadius: "8px",
                                            pointerEvents: "none",
                                            marginTop: "-10px"
                                        }}>
                                            <div style={{
                                                width: "20px",
                                                height: "20px",
                                                border: "2.5px solid rgba(255,255,255,0.4)",
                                                borderTopColor: "#fff",
                                                borderRadius: "50%",
                                                animation: "spin 0.7s linear infinite",
                                            }} />
                                        </div>
                                    )}
                                </div>
                            </div>

                        </div>
                        <div className="search">
                            <h4>Search:</h4>
                            <input
                                type="text"
                                placeholder="Search..."
                                value={inputSearch}
                                onChange={(e) => { setInputSearch(e.target.value); setHasTyped(true) }}

                                className='inputItem'
                            />
                        </div>
                    </div>
                </div>
            </div >
            <div className="menu-table-container sticky-container">
                <div className="order-list">
                    <div className="order-list-header">
                        <div className='tittle'><input type="checkbox"
                            checked={isSelectAll}
                            onChange={handleSelectAll}
                        /></div>
                        <div className="tittle">S.No.</div>
                        <div className="tittle">Image</div>
                        <div className="tittle">Title</div>
                        <div className="tittle">Created At</div>
                        <div className="tittle">Parent Category</div>
                        <div className="tittle">Sub Category</div>
                        <div className="tittle">MRP</div>
                        <div className="tittle">Selling Price</div>
                        <div className="tittle">Item code</div>
                        <div className="tittle">Status</div>
                        <div className="tittle">Action</div>
                    </div>
                </div>
            </div>
            <div className="menu-table-container hideScroll" ref={listRef} style={{ height: "400px", overflowY: "scroll" }}>
                <div className="order-list">
                    {
                        filterList?.content?.map((item, index) => (
                            <div key={item.uuid} className='order-list-row'>

                                <div className='tittle'>
                                    <input type="checkbox"
                                        checked={selectedItems.includes(item)}
                                        onChange={() => handleCheckboxChange(item)}
                                    />
                                </div>
                                <div className="tittle">{indexOfFirstItem + index + 1}</div>
                                <div className='tittle'><img src={item.itemImageUrls?.[0]} alt="" className="img" onClick={() => maginifyImage(item.itemImageUrls?.[0])} loading="lazy" /></div>
                                <div className='tittle'>{item.title}</div>
                                <div className='tittle'>{timeFormate(item.createdAtTimeStamp)}</div>
                                <div className='tittle'>{item.parentCategoryDetails.map((itm) => {
                                    return (
                                        <>
                                            <div>{itm.parentTitle}</div>
                                        </>
                                    )
                                }
                                )}
                                </div>
                                <div className='tittle'>{item.subCategoryDetails?.map((itm) => {
                                    return (
                                        <>
                                            <div>{itm.parentTitle}</div>
                                        </>
                                    )
                                })}</div>
                                <div className="tittle">{item.mrp}</div>
                                <div className='tittle'>{item.sellingPrice}
                                </div>
                                <div className="tittle">{item.itemCode}</div>
                                <div className='tittle'>
                                    <button
                                        className={`status ${item.active ? 'active-btn' : 'inactive'}`}
                                    >
                                        {item.active ? 'Active' : 'Inactive'}
                                    </button>
                                </div>
                                <div className='btn flex-btns'>
                                    {
                                        item.active ?
                                            (permission('admin/v1/item/inactivate') && (<button className={`status inactive`} title="Inactive" onClick={() => handelInactive(item.uuid)} ><CgUnavailable />Inactive</button>))
                                            :
                                            (permission('admin/v1/item/activate') && (<button className={`status active-btn`} title='Active' onClick={() => handelActive(item.uuid)}><FaCheckCircle />Active</button>))
                                    }

                                    {permission('admin/v1/item/update') && <button className="action-btn edit-btn action-btnnn" title='Edit' onClick={() => updateItem(item.uuid)}><FaEdit />Edit</button>}
                                    {
                                        item.deleted ?
                                            (permission('admin/v1/item/revive') && (<button className="status active-btn" title='Revive' onClick={() => { handelRevive(item.uuid) }}>
                                                <FaRedo />Revive
                                            </button>))
                                            :
                                            (permission('admin/v1/item/delete') && (<button className="status inactive" title='Delete' onClick={() => handelDeleted(item.uuid)}>
                                                <AiFillDelete />Delete
                                            </button>))
                                    }
                                    {item.stockOut ?
                                        (permission('admin/v1/item/update-stock-out') && (<button className="action-btnnn" title='stock-in' onClick={() => handleStokeIn(item.uuid)}><FaBox /> Stock-In</button>))
                                        :
                                        (permission('admin/v1/item/update-stock-out') && (<button className="action-btnnn" title='stock-out' onClick={() => handleStoke(item.uuid)}><FaBoxOpen /> Stock-out</button>))
                                    }

                                </div>
                            </div>
                        ))
                    }
                </div>

                <div className="pagination">
                    <span>Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filterList.totalElements)} of {filterList.totalElements} entries</span>
                    <span className="pagination-buttons">
                        <PaginationComponent currentPage={currentPage} scrollToTopOnPageChange={scrollToTopOnPageChange} setCurrentPage={setCurrentPage} totalItem={filterList.totalElements} lengthOfPage={lengthOfPage} setHasInteracted={setHasInteracted} />
                    </span>
                </div>
                <Modal
                    isOpen={popup}
                    onClose={closePop}
                    onConfirm={confirmPop}
                    action={`Are you sure you want to ${action} Item ?`}
                />

                <MagnifyImage isOpen={showImg} imgSrc={imgUrl} onClose={() => setShowImg(false)} />

            </div>
            <LoadingWait isTrue={isLoading} />
        </>
    );
}

export default Items;